import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Textarea.css';

class Textarea extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    let label = '';

    if (!!ws_data.label) {
      //label =  <label className="field_label" dangerouslySetInnerHTML={{__html: ws_data.label + (ws_data.required ? ' *' : '')}}></label> ;
    }

    const conditionalProps = {};
    
    return <div className="row">
      <div className={`field text ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>

        {label}

        <textarea 
          placeholder={`${ws_data.placeholder || ws_data.label} ${ws_data.required ? '*' : ''}`} 
          readOnly={ws_data.readonly} 
          defaultValue={formData[ws_data.fieldname]} 
          onChange={(e) => parent.handle_change(e, ws_data.fieldname)}
          {...conditionalProps} 
        ></textarea>

        {(formErrors[ws_data.fieldname].length) 
          ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors[ws_data.fieldname]}}></div> : '' }
      </div>
    </div>; 
  }
};

export default Textarea;
